import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, Link } from "react-router-dom";
import "./StudentDashboard.css";

// import { useState } from "react";
import { FaWhatsapp, FaLinkedin, FaInstagram, FaYoutube } from "react-icons/fa";

// const [openCommunity, setOpenCommunity] = useState(false);

function StudentDashboard() {
  const [openCommunity, setOpenCommunity] = useState(false);
  const { id } = useParams(); // GET student ID from URL
  const [student, setStudent] = useState(null);

  useEffect(() => {
    const fetchStudentData = async () => {
      try {
        const res = await axios.get(
          `https://devskillz-ifm6.onrender.com/api/student/${id}`,
          {
            withCredentials: true,
          }
        );
        setStudent(res.data);
      } catch (err) {
        console.error("Dashboard fetch error:", err);
      }
    };

    fetchStudentData();
  }, [id]);

  if (!student)
    return (
      <div className="loading" style={{ color: "white" }}>
        Loading your dashboard...
      </div>
    );

  return (
    <div className="student-dashboard">
      {/* =================== PROFILE HEADER =================== */}
      <div className="profile-header">
        <div className="profile-info">
          <h2>
            👋 Welcome, {student.firstName} {student.lastName}
          </h2>
          <p>{student.email}</p>
        </div>
        <div className="profile-avatar">
          <img
            src="https://cdn-icons-png.flaticon.com/512/1077/1077012.png"
            alt="avatar"
          />
        </div>
      </div>

      {/* =================== MAIN DASHBOARD LAYOUT =================== */}
      <div className="dashboard-content">
        {/* ================= LEFT PANEL ================= */}
        <div className="left-panel">
  <h3>📍 Learning Journey</h3>
  <p style={{ marginTop: "10px", color: "#ffe9a7", lineHeight: "1.6" }}>
    Your course roadmap will be available once you purchase the course.
  </p>
</div>


        {/* ================= CENTER PANEL (Purchased Courses) ================= */}
        <div className="center-panel">
          <h3>🎓 Purchased Courses</h3>

          {student.purchasedCourses?.length > 0 ? (
            student.purchasedCourses.map((course, index) => (
              <div className="course-card" key={index}>
                <h4>{course.title}</h4>
                <p>
                  <strong>Plan:</strong> {course.plan.toUpperCase()}
                </p>
                <p>
                  <strong>Amount Paid:</strong> ₹{course.amount}
                </p>
                <p>
                  <strong>Purchase Date:</strong>{" "}
                  {new Date(course.date).toLocaleDateString()}
                </p>

                <Link to={`/course/${course.courseId}`}>
                  <button className="explore-btn">Go to Course</button>
                </Link>
              </div>
            ))
          ) : (
            <p className="no-course-text">No courses purchased yet.</p>
          )}

          <Link to="/courses">
            <button className="explore-btn">Explore More Courses</button>
          </Link>
        </div>

        {/* ================= RIGHT PANEL ================= */}
        <div className="right-panel">
          <h3>👨‍🏫 Faculty & Mentor</h3>
          <div className="info-box">
            {/* <p><strong>Faculty:</strong> Mr. Ramesh Sharma</p>
            <p><strong>Mentor:</strong> Ms. Anjali Verma</p> */}

            <p>
              Your faculty details will be updated once your allotted batch
              starts.
            </p>

            <div className="info-box">
              {/* <p>Your faculty details will be updated once your allotted batch starts.</p> */}

              <div className="community-section">
                <button
                  className="community-toggle"
                  onClick={() => setOpenCommunity(!openCommunity)}
                >
                  🌐 Join our Community & Grow
                </button>

                <div
                  className={`community-links ${openCommunity ? "open" : ""}`}
                >
                  <a
                    href="https://chat.whatsapp.com/HlTJjDjT6CnEX0N1o3EL4w"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FaWhatsapp /> WhatsApp Community
                  </a>
                  <a
                    href="https://www.linkedin.com/company/devskillz-learning-hub/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FaLinkedin /> LinkedIn Profile
                  </a>
                  <a
                    href="https://www.instagram.com/devskillz_learning_hub?igsh=MXQ5eW92cjF2bTQ1ag=="
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FaInstagram /> Instagram
                  </a>
                  <a
                    href="https://www.youtube.com/@devskillzlearninghub"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FaYoutube /> Youtube
                  </a>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StudentDashboard;
